import { ArrowRight, ChevronDown } from "lucide-react";
import { COMPANY } from "@/lib/content";
import { BRAND } from "@/lib/assets";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end lg:items-center pt-32 pb-16 lg:py-32 overflow-hidden bg-navy-dark"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={BRAND.heroBackground}
          alt="Salihi Group professionals"
          className="w-full h-full object-cover object-[70%_center] md:object-[right_center]"
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
        {/* Desktop/tablet: strong-left → transparent-right gradient */}
        <div className="hidden md:block absolute inset-0 bg-gradient-to-r from-[rgba(10,24,48,0.88)] via-[rgba(10,24,48,0.55)] to-[rgba(10,24,48,0.25)]" />
        {/* Mobile: uniform-darker overlay so text sits on top */}
        <div className="md:hidden absolute inset-0 bg-[rgba(10,24,48,0.75)]" />
        {/* Vertical fade at bottom for scroll indicator */}
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-navy-dark/80" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 w-full">
        <div className="max-w-3xl">
          <div className="mb-8 animate-fade-up" style={{ animationDelay: "0.1s" }}>
            <span className="text-gold text-xs md:text-sm uppercase tracking-[0.28em] font-medium">
              Salihi Group · Est. {COMPANY.established}
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-serif text-white text-[42px] leading-[1.05] sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-[-0.015em] animate-fade-up"
            style={{ animationDelay: "0.2s" }}
          >
            Integrated <em className="text-gold not-italic font-normal">Excellence.</em>
            <br />
            Trusted Growth.
          </h1>

          <p
            className="mt-8 text-white/75 text-base md:text-lg max-w-2xl leading-relaxed font-light animate-fade-up"
            style={{ animationDelay: "0.35s" }}
          >
            A diversified professional services group headquartered in Mogadishu, Somalia — bringing legal, consulting, engineering, investment, mining, Oil & Gas, and workforce services together under one trusted corporate platform.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-start gap-4 animate-fade-up" style={{ animationDelay: "0.5s" }}>
            <a href="#companies" className="btn-gold" data-testid="hero-cta-companies">
              Explore Our Companies <ArrowRight size={16} strokeWidth={2} />
            </a>
            <a href="#contact" className="btn-outline-white" data-testid="hero-cta-contact">
              Contact Salihi Group
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <a href="#about" className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/70 hover:text-gold transition-colors" aria-label="Scroll to introduction">
        <span className="text-[10px] uppercase tracking-[0.3em] font-medium">Scroll</span>
        <span className="h-10 w-[1px] bg-gradient-to-b from-gold to-transparent" />
        <ChevronDown size={16} strokeWidth={1.5} className="animate-scroll-hint" />
      </a>
    </section>
  );
}
